var map = {
	".": "vdl2",
	"./": "vdl2",
	"./email": "Q/Dp",
	"./email.js": "Q/Dp",
	"./index": "vdl2",
	"./index.js": "vdl2",
	"./phone": "3P2A",
	"./phone.js": "3P2A"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GrQY";